// PlayButton.js
import React from 'react'
import { RoundShadowButton } from 'components'
import { playLogo } from 'images'

const PlayButton = ({ hovered, onClick }) => {
  return (
    <div className="w-6 mr-3">
      {hovered && (
        <RoundShadowButton
          removeTextComponent
          icon={playLogo}
          cicleWidthClass="w-6"
          imageWidthClass="w-2"
          onClick={onClick}
        />
      )}
    </div>
  )
}

export default PlayButton
